import {
  formatDateTime,
  parseApiDate,
} from "../../shared/utils/audbilityFormatters";
import { UPLOAD_DOCUMENT_ACTION } from "../constants";

const getLogTimestamp = (log) =>
  parseApiDate(log.date_created)?.valueOf() || 0;

const byMostRecent = (logA, logB) =>
  getLogTimestamp(logB) - getLogTimestamp(logA);

export const normalizeLogs = (apiLogs = []) =>
  [...apiLogs].sort(byMostRecent).map((log) => ({
    key: `${log.log_id}-${log.action}`,
    eventType: log.entity_type || "-",
    event: log.action || "-",
    date: formatDateTime(log.date_created),
    rawLog: log,
  }));

// O próprio payload do log traz o link assinado do arquivo enviado
export const getLogDocument = (rawLog) => {
  const { content_type, document_url, file_s3_key } = rawLog?.payload || {};

  if (rawLog?.action !== UPLOAD_DOCUMENT_ACTION || !document_url) return null;

  return {
    document: { content_type, s3_key: file_s3_key },
    url: document_url,
  };
};
